import { createExperiment } from 'shared/experiment/hook';

type FrontpageExperiments = { [key: string]: string };

const { ExperimentProvider, useExperiment } = createExperiment<FrontpageExperiments>();

export { ExperimentProvider, useExperiment };
